import React,{ Component } from 'react'
import { NavLink } from 'react-router-dom'
import { connect } from 'react-redux'
import { getMenu, getProducto, ponesacaProducto, cambiaGal, buscaProducto, traeProducto} from '../actions'
import ProductoCabecera from '../components/prodcabecera'
import ProductoInfo from '../components/productoinfo'
import ProductoGaleria from '../components/prodgal'
import ProductoData from '../containers/precios_modulo'
import ProductoOpciones from '../components/producto_opciones'
import ProductoCarro  from '../components/producto_carro'


class Producto extends Component{

	constructor(props) {
    super(props);
    this.state = {
      imgPrefix:"",
      img:""
    }
    this.ponesaca = this.ponesaca.bind(this)
    this.cambiaImgGal = this.cambiaImgGal.bind(this)
  }

     
  componentDidMount() {
    if(this.props.productos.length>0){
      var prod = this.props.productos.find(prod =>{
        return prod.id === this.props.productoId
      })

      if(!prod || prod.length<1){
        this.props.traeProducto(this.props.productoId);
      }else{
        this.props.getProducto(this.props.productoId)
      }
    }else{
      this.props.buscaProducto(this.props.productoId)
    }
  }

  ponesaca(item, cantidad){
    item.prod_nombre=this.props.producto.nombre
    item.cat_nombre=this.props.producto.categoria.nombre
    item.rubro_nombre=this.props.producto.rubro.nombre
    item.unidad_label=this.props.producto.unicad.etiqueta
    item.prod_id=this.props.producto.id

    if(this.props.producto.hasOwnProperty("custom_data")){
      console.log("TIEN CUSTON")
      item.custom_data=this.props.producto.custom_data
      item.custom="1"
    }
    //console.log(item)
    this.props.ponesacaProducto(item, cantidad)
  }

  cambiaImgGal(img){
    this.setState({img})
  }

  componentDidUpdate(prevProps, prevState){
    if(prevProps.productos.length<1){
      this.props.getProducto(this.props.productoId)
    }
    if(this.props.producto && this.state.img==""){
      this.setState({img:this.props.producto.img})
    }
  }

  	render() {
		  return (
		  	<section className="container-fluid mb-5 sombraHead mt-3 clearfix" >
          { this.props.producto != null  &&
            <div>
            <section className="container">
              <ProductoCabecera producto={this.props.producto}  ubicacion="producto" />

              <section className="col-md-4  float-right">
                <ProductoGaleria img={this.state.img} />
                <ProductoCarro carro={this.props.carro_temp} />
                <ProductoData producto={this.props.producto} tipo={1} history={this.props.history}/>
              </section>

              <ProductoOpciones producto={this.props.producto} opcionAct={ this.ponesaca } imgAct={ this.cambiaImgGal }/>
              <ProductoData producto={this.props.producto} tipo={2}  history={this.props.history}  />
            </section>

            <div className="clearfix"></div>
            <ProductoInfo producto={this.props.producto} />
            </div>
          }
        </section>
		  )
	  }
}

const mapStateToProps = (state, ownProps) => {
  return {
      menu: state.menu,
      productos: state.productos.lista,
      producto: state.productos.prod,
      carro: state.productos.carro,
      galeria: state.productos.galeria,
      carro_temp:state.productos.carroTemp
    }
}

const mapDispatchToProps = dispatch => {
  return {
    getMenu: (sector) => {
      dispatch(getMenu(sector))
    },
    getProducto: (id) => {
      dispatch(getProducto(id))
    },
    buscaProducto: (id) => {
      dispatch(buscaProducto(id))
    },
    traeProducto: (id) => {
      dispatch(traeProducto(id))
    },
    ponesacaProducto: (item, cantidad) =>{
      dispatch(ponesacaProducto(item, cantidad))
    },
    cambiaGal:(galeria) => {
      dispatch(cambiaGal(galeria))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Producto)




// WEBPACK FOOTER //
// ./src/containers/producto.js